import { useCallback, useEffect } from 'react';

const useKeyPress = (targetKey, onKeyPress, onKeyReleased) => {
  const downHandler = useCallback(
    ({ key }) => {
      if (key === targetKey) {
        onKeyPress && onKeyPress();
      }
    },
    [targetKey]
  );

  const upHandler = useCallback(
    ({ key }) => {
      if (key === targetKey) {
        onKeyReleased && onKeyReleased();
      }
    },
    [targetKey]
  );

  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [downHandler, upHandler]);
};

export default useKeyPress;
